<template>
  <div class="about">
    <div class="content content-container">
      <div class="description">
        Baunfire is a digital design agency based in the heart of Silicon Valley.
      </div>
      <a href="https://www.baunfire.com" target="_blank" class="link">Check us out at baunfire.com<span class="arrow"></span></a>
    </div>
  </div>
</template>

<script>
export default {
    name: "About",
    data: function() {
        return {
            open: false
        };
    },
    methods: {
        show: function() {
            this.$el.classList.add("show");
            this.open = true;
            this.$store.commit("disableWheel", {
                wheel: true
            });
        },
        hide: function() {
            this.$el.classList.remove("show");
            this.open = false;
            this.$store.commit("disableWheel", {
                wheel: false
            });
        }
    }
};
</script>

<style lang="scss">
.about {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    transition: transform 0.65s $primary-ease;
    transform: translate3d(100vw, 0, 0);
    background-color: #ff5a3c;
    z-index: 11;
    overflow-y: auto;
    pointer-events: none;

    @media ($mobile-screen) {
        position: fixed;
    }

    .content {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        color: #ffc3c3;
        padding: 100px 0;
        box-sizing: border-box;
        max-width: 1100px;

        @media ($tablet-screen) {
            max-width: 900px;
        }

        @media ($mobile-screen) {
            max-width: calc(100% - 60px);
        }
    }

    .description {
        width: 87%;
        @include playfair-regular;
        font-size: 80px;
        line-height: 100px;
        color: white;

        @media ($laptop-screen) {
            font-size: 70px;
        }

        @media ($small-laptop-screen) {
            font-size: 60px;
            line-height: 70px;
        }

        @media ($smallest-laptop-screen) {
            font-size: 50px;
            line-height: 60px;
        }

        @media ($mobile-screen) {
            font-size: 28px;
            line-height: 35px;
            width: 100%;
        }
    }

    .link {
        @include mukta-extralight;
        font-size: 30px;
        line-height: 40px;
        margin-top: 30px;
        color: white;

        @media ($laptop-screen) {
            font-size: 25px;
        }

        @media ($small-laptop-screen) {
            font-size: 23px;
            line-height: 35px;
        }

        @media ($mobile-screen) {
            font-size: 15px;
            line-height: 25px;
        }

        .arrow {
            display: inline-block;
            position: relative;
            margin-left: 15px;
            width: 40px;
            transition: transform 0.65s $primary-ease;
            transform-origin: left;

            &:before {
                content: "";
                display: block;
                width: 100%;
                height: 1px;
                background-color: white;
            }

            &:after {
                content: "";
                display: block;
                position: absolute;
                bottom: 0;
                right: 0;
                width: 10px;
                height: 1px;
                background-color: white;
                transform: rotate(45deg);
                transform-origin: right;
            }
        }

        &:hover {
            .arrow {
                transform: scale(1.5, 1);
            }
        }
    }

    .sns {
        @include mukta-medium;
        font-size: 16px;
        margin-top: 100px;
        margin-left: -40px;
        color: white;
        position: relative;

        @media ($mobile-screen) {
            font-size: 13px;
            margin-left: -10px;
            margin-top: 30px;
            white-space: nowrap;
        }

        &:before {
            @include playfair-regular;
            content: "@baunfire";
            position: absolute;
            top: 0;
            left: 0;
            font-size: 125px;
            color: rgba(#252524, 0.08);
            transform: translate3d(0, -50%, 0);
            pointer-events: none;

            @media ($mobile-screen) {
                font-size: 70px;
            }
        }

        li {
            margin: 0 40px;

            @media ($mobile-screen) {
                margin: 0 10px;
            }
        }

        a {
            &:after {
                content: "";
                display: block;
                width: 100%;
                height: 1px;
                background-color: white;
                transform: scale(0, 1);
                transform-origin: right;
                transition: transform 0.65s $primary-ease;
            }

            &:hover {
                &:after {
                    transform: scale(1, 1);
                    transform-origin: left;
                }
            }
        }
    }

    &.show {
        transform: translate3d(0, 0, 0);
        pointer-events: all;
    }
}
</style>